import { IDefineCommand, ICommand } from 'core-ts-types';
import { AuthenticationQueryModel } from '../queries/authentication_query_model';
import { AccountTokenServant } from '../servants/account_token_servant';
import { URLQueryModel } from '../queries/url_query_model';
import { AccountIdentityDatastore } from '../datastore/account_identity_datastore';
import { AccountStatusDatastore } from '../datastore/account_status_datastore';
import * as _4 from 'lodash4';

angular
  .module('data-ng-authentication')
  .factory(
    'loadAccountCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      ngURLQueryModel: URLQueryModel,
      ngAccountIdentityDatastore: AccountIdentityDatastore,
      ngAccountStatusDatastore: AccountStatusDatastore,
      ngAuthenticationQueryModel: AuthenticationQueryModel,
      synchronizeDeprecatedModelsCommand: ICommand
    ) =>
      defineCommand('loadAccountCommand', (deferred, credentials) => {
        $http
          .get(ngURLQueryModel.getAccountUrl(), credentials)
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            ngAccountIdentityDatastore.update(AccountTokenServant.accumulateAccountProperties(response.data));
            ngAccountStatusDatastore.update(AccountTokenServant.accumulateAccountProperties(response.data));
            synchronizeDeprecatedModelsCommand();
            deferred.resolve(ngAuthenticationQueryModel);
          })
          .catch((response: ng.IHttpPromiseCallbackArg<any>) => {
            ngAccountIdentityDatastore.initialize();
            ngAccountStatusDatastore.initialize();
            return deferred.reject({
              reason: _4.get(response, 'data.detail', '')
            });
          });
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/commands/load_account_command.ts